import Home from "@/view/dunHuang/home";

export default {
  Home
}